import { ThemeOptions } from '@mui/material';
import MuiFormControlLabel, {
    FormControlLabelProps as MuiFormControlLabelProps
} from '@mui/material/FormControlLabel';
import * as React from 'react';

import { Box } from '../box';
import { Typography } from '../typography';

const SWITCH_BASE_PADDING = 9;

export const FormControlLabel = MuiFormControlLabel;

type FormControlLabelWithDescriptionProps = TypedOmit<
    MuiFormControlLabelProps,
    'style'
> & {
    description: string;
};

export const FormControlLabelWithDescription = (
    props: FormControlLabelWithDescriptionProps
) => {
    const { label, description, ...muiProps } = props;
    return (
        <MuiFormControlLabel
            {...muiProps}
            sx={{ alignItems: 'flex-start' }}
            label={
                <Box paddingTop={`${SWITCH_BASE_PADDING}px`}>
                    {label}
                    <Typography color="text.secondary">
                        {description}
                    </Typography>
                </Box>
            }
        />
    );
};

export const formControlStyle = {
    MuiFormControlLabel: {
        styleOverrides: {
            root: {
                marginBottom: 0,
                maxWidth: 'max-content',
                userSelect: 'none'
            },
            label: ({ theme }) => ({
                fontSize: theme.typography.body1.fontSize
            })
        }
    }
} satisfies ThemeOptions['components'];
